import { Component, Input, OnInit } from '@angular/core';
import { DimensionesPMEModel, SubdimensionPMEModel } from 'src/app/model/NewFaseEstrategica.model';

@Component({
  selector: 'app-pme-subdimensiones',
  templateUrl: './pme-subdimensiones.component.html',
  styleUrls: ['./pme-subdimensiones.component.css']
})
export class PmeSubdimensionesComponent implements OnInit {

  @Input() indice : number;
  @Input() estadoData : number;
  @Input() areaNumber : number;
  @Input() dimensionData : DimensionesPMEModel;
  @Input() subdimensionData : SubdimensionPMEModel;
  @Input() simulacion: boolean;
  

  constructor(
    //@Inject(FaseEstrategicaComponent) private parentFE: FaseEstrategicaComponent,
  ) { }

  ngOnInit(): void {  

  }


  togglePriorizada(dimension: DimensionesPMEModel, subdimension: SubdimensionPMEModel): void {
    /*dimension.subdimensiones.forEach(sd => {
      if (sd !== subdimension && sd.idSubDimensionPME != 5) {
        sd.priorizada = false;
      }
    });*/
    subdimension.priorizada = !subdimension.priorizada;
  }
  
}